import _ from 'lodash';
// import { Envs } from 'scbk-services/config/enums';

/**
 * Jwt 동작 모드
 */
export enum JwtProvider {
    NONE,
    INTERNAL,
    KONG,
}

/**
 * JWT 토큰 처리 관련 Endpoint
 */
export const JwtEndpoint = {
    Login: `/auth/user/login/execute`,
    Refresh: `/jwt/refresh`,
} as const;

/**
 * 로컬 스토리지 저장 키
 */
export enum StorageKey {
    AccessToken = 'access-token',
    RefreshToken = 'refresh-token',
}

/**
 * JWT 토큰 처리 관련 에러코드
 */
export const JwtErrorCodes = {
    REQUEST_FAILURE: {
        code: 'JWT0100',
        message: '요청 처리 중 오류가 발생했습니다. 다시 시도하세요.',
    },
    ISSUE_NEW_FAILURE: {
        code: 'JWT0200',
        message: '토큰 신규 발급에 실패했습니다. 다시 로그인을 진행하세요.',
    },
    UNAUTHORIZED: {
        code: 'JWT0401',
        message: 'Access Token 사용시간이 만료되었습니다. 토큰 재발급을 진행합니다.',
    },
    NO_REFRESH_TOKEN: {
        code: 'JWT0402',
        message:
            '토큰 재발급을 위한 Refresh Token이 존재하지 않습니다. 로그아웃 후 다시 로그인을 진행하세요.',
    },
    INVALID_REFRESH_URL: {
        code: 'JWT0405',
        message:
            '토큰 재발급을 위한 Refresh Token이 존재하지 않습니다. 로그아웃 후 다시 로그인을 진행하세요.',
    },
    FORBIDDEN: {
        code: 'JWT0403',
        message: '토큰 인증에 실패 했습니다. 로그아웃 후 다시 로그인을 진행하세요.',
    },
    REFRESH_FAILURE: {
        code: 'JWT0404',
        message: '토큰 재발급에 실패했습니다. 로그아웃 후 다시 로그인을 진행하세요.',
    },
    INTERNAL_SERVER_ERROR: {
        code: 'JWT0500',
        message: '토큰 재발급에 실패했습니다. 잠시 후 재시도 해주세요.',
    },
} as const;

/**
 * JWT 토큰
 */
export interface JwtTokens {
    accessToken?: string;
    refreshToken?: string;
}

/**
 * JWT 이벤트
 */
export interface JwtEvent {
    code: string;
    message: string;
}

export enum HttpStatus {
    OK = 200,

    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,

    ELSE = -1,
}

/** 표준화된 토큰 발급 응답 */
export type NormalizedJwtResponse = {
    isSuccess: boolean;
    accessToken: string;
    refreshToken: string;
    httpStatus: HttpStatus;
};

/**
 * 토큰 재발급 URL 생성
 *  : 자체 발급 서버를 사용하고, 로컬환경에 대한 요청일 경우 처리를 위함.
 * @param error
 * @returns
 */
export const getRefreshUrl = (error: any): string | null => {
    const url = error?.config?.url;
    if (!error || !url) return null;
    
    let refreshUrl = '';
    
    // experience 분산처리 제외
    // if (
    //     import.meta.env.VITE_ENVIRONMENT === Envs.LOCAL ||
    //     import.meta.env.VITE_ENVIRONMENT === Envs.DEV
    // ) {
        refreshUrl = `/auth${JwtEndpoint.Refresh}`;
    // } else {
    //     const packageUrl = getPackageUrl(url);
    //     refreshUrl = `/${packageUrl}${JwtEndpoint.Refresh}`;
    // }

    return refreshUrl;
};

/**
 * 패키지 URL 추출
 */
// const getPackageUrl = (url: string) => {
//     console.log('jwt-commons > getPackageUrl(패키지명 추출) - url :', url);
//     let packageUrl = '';
//     if (_.isNotEmpty(url)) {
//         const match = url.match(/^\/*([^/]+)/);
//         packageUrl = match ? match[1] : '';
//     }
//     console.log('jwt-commons > getPackageUrl(패키지명 추출) - packageUrl : ', packageUrl);
//     return packageUrl;
// };
